const { vec4 } = require('glov/common/vmath.js');
const { spritesheetRegister } = require('glov/client/spritesheet.js');
module.exports = {
  name: 'forest',
  tiles: {
    cavedoor: 0,
    cavefloor: 1,
    cavesecret: 2,
    cavewall: 3,
    cavewall2: 4,
    ceiling: 5,
    cliff: 6,
    cobblestone: 7,
    deadtree: 8,
    dirt: 9,
    floor1: 10,
    floor2: 11,
    floor3: 12,
    floor4: 13,
    mosswall1: 14,
    mosswall2: 15,
    mosswall3: 16,
    mushrooms: 17,
    statue: 18,
    tree1: 19,
    tree2: 20,
    tree3: 21,
    vines_blocked: 22,
    vines_unblocked: 23
  },
  uidata: {
    rects: [
      vec4(8/1024,8/256,40/1024,40/256),
      vec4(56/1024,8/256,88/1024,40/256),
      vec4(104/1024,8/256,136/1024,40/256),
      vec4(152/1024,8/256,184/1024,40/256),
      vec4(200/1024,8/256,232/1024,40/256),
      vec4(248/1024,8/256,280/1024,40/256),
      vec4(296/1024,8/256,328/1024,40/256),
      vec4(344/1024,8/256,376/1024,40/256),
      vec4(392/1024,8/256,444/1024,58/256),
      vec4(460/1024,8/256,492/1024,40/256),
      vec4(508/1024,8/256,540/1024,40/256),
      vec4(556/1024,8/256,588/1024,40/256),
      vec4(604/1024,8/256,636/1024,40/256),
      vec4(652/1024,8/256,684/1024,40/256),
      vec4(700/1024,8/256,732/1024,40/256),
      vec4(748/1024,8/256,780/1024,40/256),
      vec4(796/1024,8/256,828/1024,40/256),
      vec4(844/1024,8/256,876/1024,40/256),
      vec4(892/1024,8/256,924/1024,40/256),
      vec4(940/1024,8/256,972/1024,40/256),
      vec4(8/1024,74/256,40/1024,106/256),
      vec4(56/1024,74/256,88/1024,106/256),
      vec4(104/1024,74/256,136/1024,106/256),
      vec4(152/1024,74/256,184/1024,106/256)
    ],
    aspect: [
      1,    1, 1, 1, 1, 1, 1,
      1, 1.04, 1, 1, 1, 1, 1,
      1,    1, 1, 1, 1, 1, 1,
      1,    1, 1
    ]
  },
  FRAME_CAVEDOOR: 0,
  FRAME_CAVEFLOOR: 1,
  FRAME_CAVESECRET: 2,
  FRAME_CAVEWALL: 3,
  FRAME_CAVEWALL2: 4,
  FRAME_CEILING: 5,
  FRAME_CLIFF: 6,
  FRAME_COBBLESTONE: 7,
  FRAME_DEADTREE: 8,
  FRAME_DIRT: 9,
  FRAME_FLOOR1: 10,
  FRAME_FLOOR2: 11,
  FRAME_FLOOR3: 12,
  FRAME_FLOOR4: 13,
  FRAME_MOSSWALL1: 14,
  FRAME_MOSSWALL2: 15,
  FRAME_MOSSWALL3: 16,
  FRAME_MUSHROOMS: 17,
  FRAME_STATUE: 18,
  FRAME_TREE1: 19,
  FRAME_TREE2: 20,
  FRAME_TREE3: 21,
  FRAME_VINES_BLOCKED: 22,
  FRAME_VINES_UNBLOCKED: 23
};
spritesheetRegister(module.exports);
